<template>
  <div v-if="!loading">
    <text-form-group
        v-model="data.headline"
        name="headline"
        label="Headline"
        :error="(errors.headline || [])[0]"
    />

    <text-form-group
        v-model="data.text"
        name="text"
        label="Text"
        :error="(errors.text || [])[0]"
    />

    <select-form-group
        v-model="data.time_based_channel_id"
        name="time_based_channel_id"
        label="Time Based Channel"
        :error="(errors.time_based_channel_id || [])[0]"
        :options="timeBasedChannelOptions"
    />
  </div>
</template>

<script>
import http from '@/http'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      timeBasedChannels: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    timeBasedChannelOptions() {
      return this.timeBasedChannels.map(timeBasedChannel => ({
        value: timeBasedChannel.id,
        label: timeBasedChannel.attributes.name
      }))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/time-based-channels', {portal: this.portal.id}).then(response => {
        this.timeBasedChannels = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
